module.exports = __webpack_public_path__ + "img/couples-069.58a5ecef.jpg";